import React, { useState, useEffect, useCallback } from 'react';
import './App.css';

// -------------------------------------------------------------
// 영역 및 유형 한글 매핑 딕셔너리
// -------------------------------------------------------------

const SERVER_BASE = process.env.REACT_APP_SERVER_BASE_URL;

const STATUS_MAP = {
  READY: { label: '대기', color: '#6b7280', bg: '#f3f4f6' },
  IN_PROGRESS: { label: '진행중', color: '#2563eb', bg: '#eff6ff' },
  COMPLETED: { label: '제출완료', color: '#059669', bg: '#ecfdf5' },
  TIMEOUT: { label: '시간초과 (일부 응시)', color: '#d97706', bg: '#fffbeb' },
  NO_RESPONSE_TIMEOUT: { label: '시간초과 (무응답)', color: '#dc2626', bg: '#fef2f2' },
};
const SECTION_NAMES = {
  personality: 'Ⅰ. 일반 인성검사',
  workstyle: 'Ⅱ. 업무성향검사',
  aptitude: 'Ⅲ. 적성·인지능력',
  sjt: 'Ⅳ. 직무상황판단',
  domain_knowledge: 'Ⅴ. 기초 직무이해'
};

const TYPE_NAMES = {
  likert: '리커트 5점',
  choice: '4지선다형',
  sjt: '직무상황판단'
};

// ⏱️ 문항 1개당 부여할 시간 (초 단위 설정: 3분 = 180초)
const SEC_PER_QUESTION = 24.44; 

function useDeviceLanguage() {
  const [lang, setLang] = useState('ko');
  useEffect(() => {
    const browserLang = navigator.language || navigator.userLanguage;
    if (browserLang && browserLang.toLowerCase().startsWith('en')) {
      setLang('en');
    } else {
      setLang('ko');
    }
  }, []);
  return lang;
}

// 시드 기반 난수 생성기 (Mulberry32)
function pseudoRandom(seed) {
  return function() {
    let t = seed += 0x6D2B79F5;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

// 문자열/숫자 시드를 숫자로 변환하는 함수
function stringToSeed(str) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (Math.imul(31, hash) + str.charCodeAt(i)) | 0;
  }
  return hash;
}

// 섹션별 셔플 처리 함수
function shuffleQuestionsBySection(questionsList, candidateId) {
  if (!questionsList || questionsList.length === 0) return [];

  // 섹션별 그룹화
  const sections = {};
  questionsList.forEach((q) => {
    if (!sections[q.section]) sections[q.section] = [];
    sections[q.section].push(q);
  });

  const result = [];
  const baseSeed = stringToSeed(String(candidateId));

  // 각 섹션 내에서만 문항 순서 셔플
  Object.keys(sections).forEach((secKey, secIdx) => {
    const group = [...sections[secKey]];
    const rng = pseudoRandom(baseSeed + secIdx); // 섹션별 고유 난수 generator

    // Fisher-Yates Shuffle
    for (let i = group.length - 1; i > 0; i--) {
      const j = Math.floor(rng() * (i + 1));
      [group[i], group[j]] = [group[j], group[i]];
    }

    result.push(...group);
  });

  return result;
}

// -------------------------------------------------------------
// 로그인 컴포넌트
// -------------------------------------------------------------
// function LoginForm({ onLoginSuccess }) {
//   const lang = useDeviceLanguage();
//   const [email, setEmail] = useState('');
//   const [authCode, setAuthCode] = useState('');
//   const [errorMsg, setErrorMsg] = useState('');

//   const t = {
//     ko: {
//       title: '머신비전 필드 엔지니어 인적성검사',
//       subtitle: '로그인을 위해 이메일과 인증번호를 입력해주세요.',
//       email: '이메일 주소',
//       code: '고유 인증번호 (8자리)',
//       btn: '검사 응시',
//       fail: '이메일 또는 인증번호가 올바르지 않습니다.',
//       serverErr: '서버 연결 실패'
//     },
//     en: {
//       title: 'Machine Vision Field Engineer Aptitude Test',
//       subtitle: 'Please enter your email and authentication code to login.',
//       email: 'Email Address',
//       code: 'Authentication Code (8 chars)',
//       btn: 'Start Examination',
//       fail: 'Invalid email or authentication code.',
//       serverErr: 'Server connection failed'
//     }
//   }[lang];

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setErrorMsg('');
//     try {
//       const res = await fetch(`${SERVER_BASE}/api/auth/login`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ email, authCode })
//       });
//       const data = await res.json();
//       if (data.success) {
//         onLoginSuccess(data.candidate);
//       } else {
//         setErrorMsg(data.message || t.fail);
//       }
//     } catch (err) {
//       setErrorMsg(t.serverErr);
//     }
//   };

//   return (
//     <div style={{ minHeight: '100vh', background: '#f3f6fa', display: 'grid', placeItems: 'center', padding: '20px' }}>
//       <div style={{ background: '#fff', borderRadius: '18px', border: '1px solid #d9e1ea', padding: '36px', maxWidth: '420px', width: '100%', boxShadow: '0 18px 45px rgba(16,24,40,.1)', textAlign: 'center' }}>
//         <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px', marginBottom: '20px' }}>
//           <div style={{ width: '42px', height: '42px', borderRadius: '13px', background: 'linear-gradient(135deg,#3bd0bb,#1c9a8b)', display: 'grid', placeItems: 'center', fontWeight: '900', color: '#fff', flexShrink: 0 }}>
//             GLIM
//           </div>
//           <div style={{ textAlign: 'left' }}>
//             <div style={{ fontSize: '18px', fontWeight: '800', lineHeight: '1.2' }}>{t.title}</div>
//             <div style={{ fontSize: '12px', color: '#667085', lineHeight: '1.3', marginTop: '2px' }}>Pilot Examination</div>
//           </div>
//         </div>

//         <p style={{ fontSize: '13px', color: '#667085', marginBottom: '24px', textAlign: 'center' }}>{t.subtitle}</p>

//         <form onSubmit={handleSubmit}>
//           <div style={{ marginBottom: '16px', textAlign: 'center' }}>
//             <label style={{ display: 'block', fontSize: '13px', fontWeight: '700', marginBottom: '6px' }}>{t.email}</label>
//             <input
//               type="email"
//               required
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               style={{ width: '100%', padding: '12px', borderRadius: '10px', border: '1px solid #d9e1ea', boxSizing: 'border-box' }}
//             />
//           </div>
//           <div style={{ marginBottom: '20px', textAlign: 'center' }}>
//             <label style={{ display: 'block', fontSize: '13px', fontWeight: '700', marginBottom: '6px' }}>{t.code}</label>
//             <input
//               type="text"
//               required
//               maxLength={8}
//               placeholder="e.g. A7K2M9X4"
//               value={authCode}
//               onChange={(e) => setAuthCode(e.target.value)}
//               style={{ width: '100%', padding: '12px', borderRadius: '10px', border: '1px solid #d9e1ea', textTransform: 'uppercase', boxSizing: 'border-box' }}
//             />
//           </div>
//           {errorMsg && <p style={{ color: '#d92d20', fontSize: '13px', marginBottom: '16px', lineHeight: 1.4, textAlign: 'center' }}>{errorMsg}</p>}
//           <button type="submit" style={{ width: '100%', padding: '14px', borderRadius: '11px', background: '#1c9a8b', color: '#fff', border: 'none', fontWeight: '800', fontSize: '15px', cursor: 'pointer' }}>
//             {t.btn}
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// }
function LoginForm({ onLoginSuccess }) {
  const lang = useDeviceLanguage();
  const [email, setEmail] = useState('');
  const [authCode, setAuthCode] = useState('');
  const [errorMsg, setErrorMsg] = useState('');

  const [questions, setQuestions] = useState([]);
  
  const [step, setStep] = useState('login'); // 'login' | 'consent'
  const [candidateData, setCandidateData] = useState(null);
  const [agreePrivacy, setAgreePrivacy] = useState(false);
  const [agreeUsage, setAgreeUsage] = useState(false);

  useEffect(() => {
    fetch(`${SERVER_BASE}/api/questions`)
      .then((res) => res.json())
      .then((data) => setQuestions(data))
      .catch((err) => console.error(err));
  }, []);

  const totalExamDurationSec = questions.length * SEC_PER_QUESTION;
  const totalExamDurationMin = Math.ceil(totalExamDurationSec / 60);

  const t = {
    ko: {
      title: '머신비전 필드 엔지니어 인적성검사',
      subtitle: '로그인을 위해 이메일과 인증번호를 입력해주세요.',
      email: '이메일 주소',
      code: '고유 인증번호 (8자리)',
      btn: '검사 응시',
      fail: '이메일 또는 인증번호가 올바르지 않습니다.',
      serverErr: '서버 연결 실패',
      consentTitle: '인적성검사 안내 및 개인정보 수집·이용 동의',
      consentSub: 'GLIM은 채용전형 과정에서 자체 인적성검사를 실시하기 위하여 아래와 같이 안내 및 개인정보를 수집·이용하고자 합니다.',
      examInfoTitle: '⏱️ 검사 안내사항',
      timeLimitLabel: '총 검사 제한시간',
      timeLimitVal: `${totalExamDurationMin}분 (총 ${questions.length}문항)`,
      section1Title: '1. 개인정보 수집·이용 목적',
      section1List: [
        '인적성검사 응시자 본인 확인',
        '인적성검사 실시 및 결과 산출',
        '인적성검사 결과 분석',
        '지원자의 직무 적합성 및 조직 적합성 등 채용전형 평가',
        '채용전형 진행 및 결과 관리'
      ],
      section2Title: '2. 수집·이용하는 개인정보 항목',
      section2Sub1: '① 응시자 정보: 성명, 이메일, 지원직무, 지원자 식별정보(지원자번호 등)',
      section2Sub2: '② 인적성검사 정보: 인적성검사 문항별 응답내용, 검사점수, 검사결과 및 평가결과',
      section2Note: '※ 본 인적성검사에서는 건강정보, 종교, 정치적 견해 등 「개인정보 보호법」상 민감정보를 수집하지 않습니다.',
      section3Title: '3. 개인정보 보유 및 이용기간',
      section3Text: '수집된 개인정보 및 인적성검사 결과는 채용전형 종료일로부터 6개월간 보관한 후 지체 없이 파기합니다. 다만, 관계 법령에 따라 보존할 필요가 있는 경우에는 해당 법령에서 정한 기간 동안 보관할 수 있습니다.',
      section4Title: '4. 개인정보 수집·이용 동의 거부에 관한 사항',
      section4Text: '지원자는 개인정보 수집·이용에 대한 동의를 거부할 권리가 있습니다. 다만, 위 개인정보는 인적성검사 실시 및 채용전형 평가를 위하여 필요한 정보이므로, 동의를 거부하는 경우 인적성검사 응시 및 해당 채용전형 진행이 제한될 수 있습니다.',
      chk1: '[필수] 개인정보 수집·이용에 동의합니다.',
      chk2: '[필수] 인적성검사 결과의 채용평가 활용에 동의 및 확인하였습니다.',
      startBtn: '동의하고 검사 시작',
      chkErr: '모든 항목에 동의해주셔야 검사진행이 가능합니다.'
    },
    en: {
      title: 'Machine Vision Field Engineer Aptitude Test',
      subtitle: 'Please enter your email and authentication code to login.',
      email: 'Email Address',
      code: 'Authentication Code (8 chars)',
      btn: 'Start Examination',
      fail: 'Invalid email or authentication code.',
      serverErr: 'Server connection failed',
      consentTitle: 'Test Information & Consent to Collection and Use of Personal Information',
      consentSub: 'GLIM collects and uses personal information as follows to conduct our aptitude test during the recruitment process.',
      examInfoTitle: '⏱️ Examination Information',
      timeLimitLabel: 'Total Time Limit',
      timeLimitVal: `${totalExamDurationMin} mins (${questions.length} questions)`,
      section1Title: '1. Purpose of Collection and Use',
      section1List: [
        'Identification of test taker',
        'Conducting tests and calculating scores',
        'Analysis of test results',
        'Evaluation of candidate\'s job and organizational fit',
        'Recruitment process and result management'
      ],
      section2Title: '2. Items to be Collected and Used',
      section2Sub1: '① Applicant Info: Name, Email, Target Position, Candidate ID',
      section2Sub2: '② Test Info: Test responses per item, Test scores, Test and evaluation results',
      section2Note: '※ Sensitive information (health, religion, political views, etc.) is NOT collected.',
      section3Title: '3. Retention and Use Period',
      section3Text: 'Retained for 6 months after the recruitment process ends and destroyed immediately without delay. (Except where retention is required by law).',
      section4Title: '4. Right to Refuse Consent & Consequences',
      section4Text: 'You have the right to refuse consent. However, refusal will restrict you from taking the aptitude test and continuing the recruitment process.',
      chk1: '[Required] I agree to the collection and use of personal information.',
      chk2: '[Required] I confirm that test results may be used for evaluation.',
      startBtn: 'Agree and Start Test',
      chkErr: 'Please agree to all required items to proceed.'
    }
  }[lang || 'ko'];

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg('');
    try {
      const res = await fetch(`${SERVER_BASE}/api/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, authCode })
      });
      const data = await res.json();
      if (data.success) {
        setCandidateData(data.candidate);
        
        // ⭐️ 이미 시험을 시작했던 유저(재접속 등)라면 동의 화면을 거치지 않고 바로 진행하거나, 
        // 요구사항에 맞춰 동의 단계로 넘깁니다.
        setStep('consent');
      } else {
        setErrorMsg(data.message || t.fail);
      }
    } catch (err) {
      setErrorMsg(t.serverErr);
    }
  };

  // ⭐️ 동의 완료 버튼 클릭 시 실제 검사 시작 시간 기록 API 호출
  const handleConsentSubmit = async (e) => {
    e.preventDefault();
    if (!agreePrivacy || !agreeUsage) {
      setErrorMsg(t.chkErr);
      return;
    }

    try {
      const res = await fetch(`${SERVER_BASE}/api/auth/start`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ candidateId: candidateData.id })
      });
      const data = await res.json();

      if (data.success) {
        // 기록된 started_at을 가지고 메인 검사 페이지로 넘아감
        onLoginSuccess(data.candidate);
      } else {
        setErrorMsg(data.message || t.serverErr);
      }
    } catch (err) {
      setErrorMsg(t.serverErr);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f3f6fa', display: 'grid', placeItems: 'center', padding: '20px' }}>
      <div style={{ background: '#fff', borderRadius: '18px', border: '1px solid #d9e1ea', padding: '36px', maxWidth: step === 'login' ? '420px' : '640px', width: '100%', boxShadow: '0 18px 45px rgba(16,24,40,.1)', transition: 'max-width 0.3s ease' }}>
        
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px', marginBottom: '20px' }}>
          <div style={{ width: '42px', height: '42px', borderRadius: '13px', background: 'linear-gradient(135deg,#3bd0bb,#1c9a8b)', display: 'grid', placeItems: 'center', fontWeight: '900', color: '#fff', flexShrink: 0 }}>
            GLIM
          </div>
          <div style={{ textAlign: 'left' }}>
            <div style={{ fontSize: '18px', fontWeight: '800', lineHeight: '1.2' }}>{t.title}</div>
            <div style={{ fontSize: '12px', color: '#667085', lineHeight: '1.3', marginTop: '2px' }}>Pilot Examination</div>
          </div>
        </div>

        {/* 1단계: 로그인 */}
        {step === 'login' && (
          <>
            <p style={{ fontSize: '13px', color: '#667085', marginBottom: '24px', textAlign: 'center' }}>{t.subtitle}</p>
            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: '16px', textAlign: 'left' }}>
                <label style={{ display: 'block', fontSize: '13px', fontWeight: '700', marginBottom: '6px' }}>{t.email}</label>
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  style={{ width: '100%', padding: '12px', borderRadius: '10px', border: '1px solid #d9e1ea', boxSizing: 'border-box' }}
                />
              </div>
              <div style={{ marginBottom: '20px', textAlign: 'left' }}>
                <label style={{ display: 'block', fontSize: '13px', fontWeight: '700', marginBottom: '6px' }}>{t.code}</label>
                <input
                  type="text"
                  required
                  maxLength={8}
                  placeholder="e.g. A7K2M9X4"
                  value={authCode}
                  onChange={(e) => setAuthCode(e.target.value)}
                  style={{ width: '100%', padding: '12px', borderRadius: '10px', border: '1px solid #d9e1ea', textTransform: 'uppercase', boxSizing: 'border-box' }}
                />
              </div>
              {errorMsg && <p style={{ color: '#d92d20', fontSize: '13px', marginBottom: '16px', lineHeight: 1.4, textAlign: 'center' }}>{errorMsg}</p>}
              <button type="submit" style={{ width: '100%', padding: '14px', borderRadius: '11px', background: '#1c9a8b', color: '#fff', border: 'none', fontWeight: '800', fontSize: '15px', cursor: 'pointer' }}>
                {t.btn}
              </button>
            </form>
          </>
        )}

        {/* 2단계: 안내사항 및 개인정보 동의 (이 단계에서는 제한시간이 차감되지 않음) */}
        {step === 'consent' && (
          <div>
            <h3 style={{ fontSize: '16px', fontWeight: '800', marginBottom: '8px', color: '#101828', textAlign: 'center' }}>{t.consentTitle}</h3>
            <p style={{ fontSize: '12px', color: '#667085', marginBottom: '16px', lineHeight: '1.4' }}>{t.consentSub}</p>

            <div style={{ background: '#eefaf8', border: '1px solid #b2e2dc', borderRadius: '10px', padding: '14px 16px', marginBottom: '16px', textAlign: 'left', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ fontSize: '13px', fontWeight: '700', color: '#146b60' }}>{t.examInfoTitle}</span>
              <span style={{ fontSize: '13px', fontWeight: '800', color: '#1c9a8b' }}>
                {t.timeLimitLabel}: <span style={{ textDecoration: 'underline' }}>{t.timeLimitVal}</span>
              </span>
            </div>

            <div style={{ background: '#f8fafc', border: '1px solid #eaecf0', borderRadius: '10px', padding: '18px', textAlign: 'left', fontSize: '12px', color: '#344054', marginBottom: '20px', lineHeight: '1.6' }}>
              <strong>{t.section1Title}</strong>
              <ul style={{ paddingLeft: '18px', marginTop: '4px', marginBottom: '12px' }}>
                {t.section1List.map((item, idx) => <li key={idx}>{item}</li>)}
              </ul>

              <strong>{t.section2Title}</strong>
              <p style={{ margin: '4px 0' }}>{t.section2Sub1}</p>
              <p style={{ margin: '4px 0' }}>{t.section2Sub2}</p>
              <p style={{ margin: '4px 0 12px 0', color: '#667085', fontSize: '11px' }}>{t.section2Note}</p>

              <strong>{t.section3Title}</strong>
              <p style={{ margin: '4px 0 12px 0' }}>{t.section3Text}</p>

              <strong>{t.section4Title}</strong>
              <p style={{ margin: '4px 0 0 0' }}>{t.section4Text}</p>
            </div>

            <form onSubmit={handleConsentSubmit} style={{ textAlign: 'left' }}>
              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', fontWeight: '600', marginBottom: '10px', cursor: 'pointer' }}>
                <input
                  type="checkbox"
                  checked={agreePrivacy}
                  onChange={(e) => { setAgreePrivacy(e.target.checked); setErrorMsg(''); }}
                  style={{ width: '16px', height: '16px', accentColor: '#1c9a8b' }}
                />
                {t.chk1}
              </label>

              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', fontWeight: '600', marginBottom: '20px', cursor: 'pointer' }}>
                <input
                  type="checkbox"
                  checked={agreeUsage}
                  onChange={(e) => { setAgreeUsage(e.target.checked); setErrorMsg(''); }}
                  style={{ width: '16px', height: '16px', accentColor: '#1c9a8b' }}
                />
                {t.chk2}
              </label>

              {errorMsg && <p style={{ color: '#d92d20', fontSize: '13px', marginBottom: '16px', lineHeight: 1.4, textAlign: 'center' }}>{errorMsg}</p>}

              <button type="submit" style={{ width: '100%', padding: '14px', borderRadius: '11px', background: '#1c9a8b', color: '#fff', border: 'none', fontWeight: '800', fontSize: '15px', cursor: 'pointer' }}>
                {t.startBtn}
              </button>
            </form>
          </div>
        )}

      </div>
    </div>
  );
}

// -------------------------------------------------------------
// 옵션 데이터 안전 파싱 함수
// -------------------------------------------------------------
const parseOptionsData = (raw) => {
  if (!raw) return { options: [] };
  let parsed = raw;
  while (typeof parsed === 'string') {
    try {
      parsed = JSON.parse(parsed);
    } catch (e) {
      break;
    }
  }
  return parsed && typeof parsed === 'object' ? parsed : { options: [] };
};

// -------------------------------------------------------------
// 인적성 검사 메인 화면
// -------------------------------------------------------------
function ExamPage({ candidate: initialCandidate, onExamComplete }) {
  const lang = useDeviceLanguage();
  const [candidate, setCandidate] = useState(initialCandidate);
  const [questions, setQuestions] = useState([]);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  
  const [currentSection, setCurrentSection] = useState(() => {
    return localStorage.getItem(`gmv_sec_${initialCandidate.id}`) || 'personality';
  });

  const [currentPage, setCurrentPage] = useState(1);

  const [answers, setAnswers] = useState(() => {
    const saved = localStorage.getItem(`gmv_ans_${initialCandidate.id}`);
    return saved ? JSON.parse(saved) : {};
  });

  const [timeLeft, setTimeLeft] = useState(0);
  const [showToast, setShowToast] = useState(false);
  const [toastMsg, setToastMsg] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const i18n = {
    ko: {
      sections: {
        personality: { no: 'Ⅰ', name: '일반 인성검사', desc: '정답은 없습니다. 평소 자신의 모습에 가장 가까운 정도를 선택해 주세요.' },
        workstyle: { no: 'Ⅱ', name: '업무성향검사', desc: '평소 일을 처리하는 방식에 가까운 정도를 선택해 주세요.' },
        aptitude: { no: 'Ⅲ', name: '적성·인지능력', desc: '안내문 및 규칙에 따라 정확한 정답 하나를 선택해 주세요.' },
        sjt: { no: 'Ⅳ', name: '직무상황판단', desc: '각 상황에서 가장 적절한 행동과 가장 부적절한 행동을 각각 선택해 주세요.' },
        domain_knowledge: { no: 'Ⅴ', name: '기초 직무이해', desc: '머신비전, 광학, 제어 분야의 기초 직무 지식 관련 문항입니다.' }
      },
      likert: ["전혀 그렇지 않다", "그렇지 않은 편이다", "보통이다", "그런 편이다", "매우 그렇다"],
      autoSave: "자동 저장됨",
      prev: "이전",
      next: "다음",
      submit: "제출 확인",
      sjtBest: "가장 적절",
      sjtWorst: "가장 부적절",
      modalTitle: "검사 제출 확인",
      modalDesc: "제출 후에는 응답을 수정할 수 없으며 세션이 종료됩니다.",
      answered: "응답 완료",
      unanswered: "미응답",
      continue: "계속 응답",
      finalSubmit: "최종 제출",
      submitting: "제출 중...",
      sjtWarn: "가장 적절한 행동과 가장 부적절한 행동은 서로 다르게 선택해야 합니다.",
      unansweredWarn: "현재 페이지의 모든 문항에 응답해야 다음으로 이동할 수 있습니다.",
      progressTitle: "전체 진행률",
      qCountSuffix: "문항",
      qListTitle: "문항 목록",
      pageText: "페이지",
      totalPrefix: "",
      noOptions: "등록된 보기가 없습니다.",
      timeOverMsg: "응시 시간이 종료되어 답안 제출 처리됩니다.",
      submitErr: "제출 중 오류가 발생했습니다. 다시 시도해 주세요."
    },
    en: {
      sections: {
        personality: { no: 'I', name: 'General Personality', desc: 'Select options that best describe you.' },
        workstyle: { no: 'II', name: 'Work Style', desc: 'Select options closest to your working style.' },
        aptitude: { no: 'III', name: 'Aptitude & Cognitive', desc: 'Select the correct answer based on rules.' },
        sjt: { no: 'IV', name: 'Situational Judgment', desc: 'Select the MOST and LEAST appropriate actions.' },
        domain_knowledge: { no: 'V', name: 'Domain Knowledge', desc: 'Basic knowledge related to Machine Vision and Automation.' }
      },
      likert: ["Strongly Disagree", "Disagree", "Neutral", "Agree", "Strongly Agree"],
      autoSave: "Auto-saved",
      prev: "Previous",
      next: "Next",
      submit: "Submit Exam",
      sjtBest: "Most Appropriate",
      sjtWorst: "Least Appropriate",
      modalTitle: "Submit Examination",
      modalDesc: "Responses cannot be modified after submission, and your session will end.",
      answered: "Answered",
      unanswered: "Unanswered",
      continue: "Continue",
      finalSubmit: "Final Submit",
      submitting: "Submitting...",
      sjtWarn: "Most and Least options must be different.",
      unansweredWarn: "Please answer all questions on the current page before proceeding.",
      progressTitle: "Overall Progress",
      qCountSuffix: "Questions",
      qListTitle: "Question List",
      pageText: "Page",
      totalPrefix: "Total",
      noOptions: "No options registered.",
      timeOverMsg: "Exam time has expired. Submitting your test.",
      submitErr: "Submission failed. Please try again."
    }
  }[lang];

  const sectionsList = ['personality', 'workstyle', 'aptitude', 'sjt', 'domain_knowledge'];
  const QUESTIONS_PER_PAGE = 4;

  const triggerToast = (msg) => {
    setToastMsg(msg);
    setShowToast(true);
    setTimeout(() => setShowToast(false), 2500);
  };

  // ⭐️ 1. 로컬스토리지 조작 방지: DB에서 실시간 started_at 조회
  useEffect(() => {
    fetch(`${SERVER_BASE}/api/candidate/${initialCandidate.id}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success && data.candidate) {
          setCandidate(data.candidate);
        }
      })
      .catch((err) => console.error('Candidate fetch error:', err));
  }, [initialCandidate.id]);

  // 문항 로드
  // useEffect(() => {
  //   fetch(`${SERVER_BASE}/api/questions`)
  //     .then((res) => res.json())
  //     .then((data) => setQuestions(data))
  //     .catch((err) => console.error(err));
  // }, []);
  useEffect(() => {
    fetch(`${SERVER_BASE}/api/questions`)
      .then((res) => res.json())
      .then((data) => {
        // 응시자 ID를 기반으로 섹션 내 셔플 적용
        const shuffledData = shuffleQuestionsBySection(data, initialCandidate.id);
        setQuestions(shuffledData);
      })
      .catch((err) => console.error(err));
  }, [initialCandidate.id]);

  // ⭐️ 2. 제출 로직 (시간초과 시 빈 값 제출 처리 지원)
  const handleSubmitFinal = useCallback(async (isTimeOver = false) => {
    if (isSubmitting) return;
    setIsSubmitting(true);

    try {
      const response = await fetch(`${SERVER_BASE}/api/submit`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          candidate_id: candidate.id,
          answers: answers || {},
          is_time_over: isTimeOver // ⭐️ 전달받은 isTimeOver (true/false) 값을 그대로 전달
        }),
      });

      if (!response.ok) throw new Error('제출 실패');

      Object.keys(localStorage).forEach((key) => {
        if (key.startsWith('gmv_')) {
          localStorage.removeItem(key);
        }
      });

      // 성공 처리...
      setShowModal(false);
      setShowSuccessModal(true);
    } catch (err) {
      console.error(err);
    } finally {
      setIsSubmitting(false);
    }
  }, [answers, candidate.id, isSubmitting]);

  // ⭐️ 3. 타이머 제어 (DB started_at 기준 계산)
  useEffect(() => {
    if (!candidate || !candidate.started_at || questions.length === 0) return;

    const totalExamDurationSec = questions.length * SEC_PER_QUESTION;

    const calculateTimeLeft = () => {
      const startTime = new Date(candidate.started_at).getTime();
      const now = Date.now();
      const elapsedSec = Math.floor((now - startTime) / 1000);
      const remaining = Math.floor(totalExamDurationSec - elapsedSec);

      if (remaining <= 0 && !showSuccessModal) {
        setTimeLeft(0);
        triggerToast(i18n.timeOverMsg);
        handleSubmitFinal(true);
        return false;
      } else if(!showSuccessModal) {
        setTimeLeft(remaining);
        return true;
      }
    };

    calculateTimeLeft();
    const timer = setInterval(() => {
      const isRunning = calculateTimeLeft();
      if (!isRunning) clearInterval(timer);
    }, 1000);

    return () => clearInterval(timer);
  }, [candidate, questions, handleSubmitFinal, showSuccessModal, i18n.timeOverMsg]);

  const isQuestionAnswered = (q) => {
    const qType = (q.question_type || '').toLowerCase();
    if (qType === 'sjt') {
      return answers[`sjt-${q.id}-best`] !== undefined && answers[`sjt-${q.id}-worst`] !== undefined;
    }
    return answers[q.id] !== undefined;
  };

  const handleSectionChange = (sec) => {
    if (sectionsList.indexOf(sec) > sectionsList.indexOf(currentSection)) {
      if (!checkCurrentPageAnswered()) return;
    }
    setCurrentSection(sec);
    setCurrentPage(1);
    localStorage.setItem(`gmv_sec_${candidate.id}`, sec);
    window.scrollTo(0, 0);
  };

  const handleRadioChange = (key, val) => {
    const updated = { ...answers, [key]: val };
    setAnswers(updated);
    localStorage.setItem(`gmv_ans_${candidate.id}`, JSON.stringify(updated));
    triggerToast(lang === 'en' ? 'Auto-saved.' : '응답이 자동 저장되었습니다.');
  };

  const handleSJTChange = (qId, type, optIdx) => {
    const otherType = type === 'best' ? 'worst' : 'best';
    const otherVal = answers[`sjt-${qId}-${otherType}`];

    if (otherVal === optIdx) {
      triggerToast(i18n.sjtWarn);
      return;
    }
    handleRadioChange(`sjt-${qId}-${type}`, optIdx);
  };

  const formatTime = (secs) => {
    const m = String(Math.floor(secs / 60)).padStart(2, '0');
    const s = String(secs % 60).padStart(2, '0');
    return `${m}:${s}`;
  };

  const currentSectionQuestions = questions.filter((q) => q.section === currentSection);
  const totalPages = Math.ceil(currentSectionQuestions.length / QUESTIONS_PER_PAGE) || 1;
  
  const paginatedQuestions = currentSectionQuestions.slice(
    (currentPage - 1) * QUESTIONS_PER_PAGE,
    currentPage * QUESTIONS_PER_PAGE
  );

  const totalQuestions = questions.length;
  const answeredCount = questions.filter(isQuestionAnswered).length;
  const progressPct = totalQuestions > 0 ? Math.round((answeredCount / totalQuestions) * 100) : 0;

  const currentSecIdx = sectionsList.indexOf(currentSection);
  const isFirstOverall = currentSecIdx === 0 && currentPage === 1;
  const isLastOverall = currentSecIdx === sectionsList.length - 1 && currentPage === totalPages;

  const checkCurrentPageAnswered = () => {
    const unansweredExist = paginatedQuestions.some((q) => !isQuestionAnswered(q));
    if (unansweredExist) {
      // triggerToast(i18n.unansweredWarn);
      // return false;
    }
    return true;
  };

  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    } else if (currentSecIdx > 0) {
      const prevSec = sectionsList[currentSecIdx - 1];
      const prevSecQuestions = questions.filter((q) => q.section === prevSec);
      const prevSecTotalPages = Math.ceil(prevSecQuestions.length / QUESTIONS_PER_PAGE) || 1;
      setCurrentSection(prevSec);
      setCurrentPage(prevSecTotalPages);
      localStorage.setItem(`gmv_sec_${candidate.id}`, prevSec);
    }
    window.scrollTo(0, 0);
  };

  const handleNext = () => {
    if (!checkCurrentPageAnswered()) return;

    if (currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
    } else if (currentSecIdx < sectionsList.length - 1) {
      const nextSec = sectionsList[currentSecIdx + 1];
      setCurrentSection(nextSec);
      setCurrentPage(1);
      localStorage.setItem(`gmv_sec_${candidate.id}`, nextSec);
    }
    window.scrollTo(0, 0);
  };

  return (
    <div className="app" style={{ minHeight: '100vh', background: '#f3f6fa' }}>
      {/* Top Bar */}
      <header style={{ height: '74px', background: 'linear-gradient(110deg,#12233f,#1a3155)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 28px', color: '#fff', position: 'sticky', top: 0, zIndex: 50 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
          <div style={{ width: '42px', height: '42px', borderRadius: '13px', background: 'linear-gradient(135deg,#3bd0bb,#1c9a8b)', display: 'grid', placeItems: 'center', fontWeight: '900', color: '#fff', flexShrink: 0 }}>GLIM</div>
          
          <div style={{ textAlign: 'left' }}>
            <div style={{ fontSize: '17px', fontWeight: '800', lineHeight: '1.2', textAlign: 'left' }}>
              {lang === 'en' ? 'Machine Vision Field Engineer Exam' : '머신비전 필드 엔지니어 인적성검사'}
            </div>
            <div style={{ fontSize: '12px', color: '#cbd5e1', lineHeight: '1.3', marginTop: '3px', textAlign: 'left' }}>
              Candidate: {candidate.name} ({candidate.email})
            </div>
          </div>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '18px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', color: '#d6f5ef' }}>
            <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#52e0c7', display: 'inline-block' }}></span>
            {i18n.autoSave}
          </div>
          <div style={{ padding: '8px 13px', borderRadius: '10px', background: 'rgba(255,255,255,.11)', fontWeight: '800', letterSpacing: '.5px', color: timeLeft < 300 ? '#ff8b8b' : '#fff' }}>
            {formatTime(timeLeft)}
          </div>
        </div>
      </header>

      {/* Main Layout */}
      <div style={{ display: 'grid', gridTemplateColumns: '286px minmax(0,1fr)', minHeight: 'calc(100vh - 74px)' }}>
        {/* Sidebar */}
        <aside style={{ background: '#fff', borderRight: '1px solid #d9e1ea', padding: '24px 18px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', fontWeight: '700', marginBottom: '8px' }}>
            <span>{i18n.progressTitle}</span><span>{progressPct}%</span>
          </div>
          <div style={{ height: '9px', background: '#e7edf4', borderRadius: '99px', overflow: 'hidden', marginBottom: '20px' }}>
            <div style={{ height: '100%', width: `${progressPct}%`, background: 'linear-gradient(90deg,#1c9a8b,#49c9b7)', transition: 'width .25s ease' }}></div>
          </div>

          <nav style={{ display: 'flex', flexDirection: 'column', gap: '9px' }}>
            {sectionsList.map((secKey) => {
              const secInfo = i18n.sections[secKey];
              const secQList = questions.filter((q) => q.section === secKey);
              const secAnsCount = secQList.filter(isQuestionAnswered).length;
              const isActive = currentSection === secKey;

              return (
                <button
                  key={secKey}
                  onClick={() => handleSectionChange(secKey)}
                  style={{
                    width: '100%', textAlign: 'left', border: '1px solid transparent', padding: '13px 12px', borderRadius: '13px',
                    display: 'grid', gridTemplateColumns: '32px 1fr auto', alignItems: 'center', gap: '10px',
                    background: isActive ? '#e9f7f4' : 'transparent',
                    borderColor: isActive ? '#bde7df' : 'transparent',
                    color: isActive ? '#0c6258' : '#1d2939', cursor: 'pointer'
                  }}
                >
                  <span style={{ width: '30px', height: '30px', borderRadius: '10px', background: isActive ? '#fff' : '#eef2f6', display: 'grid', placeItems: 'center', fontSize: '12px', fontWeight: '800' }}>{secInfo.no}</span>
                  <span>
                    <div style={{ fontSize: '13px', fontWeight: '800', textAlign: 'left' }}>{secInfo.name}</div>
                    <div style={{ fontSize: '11px', color: '#667085', textAlign: 'left' }}>{secQList.length} {i18n.qCountSuffix}</div>
                  </span>
                  <span style={{ fontSize: '12px', color: '#667085' }}>{secAnsCount}/{secQList.length}</span>
                </button>
              );
            })}
          </nav>
        </aside>

        {/* Main Content Area */}
        <main style={{ padding: '30px 34px 110px', maxWidth: '1180px', width: '100%', margin: '0 auto' }}>
          <div style={{ background: 'linear-gradient(135deg,#fff,#f7fbff)', border: '1px solid #dce6f0', borderRadius: '18px', padding: '24px 26px', marginBottom: '20px', textAlign: 'left' }}>
            <div style={{ fontSize: '12px', fontWeight: '800', color: '#127568', textTransform: 'uppercase' }}>Section {i18n.sections[currentSection].no}</div>
            <h1 style={{ margin: '8px 0 7px', fontSize: '27px', textAlign: 'left' }}>{i18n.sections[currentSection].name}</h1>
            <p style={{ margin: 0, color: '#667085', fontSize: '14px', textAlign: 'left' }}>{i18n.sections[currentSection].desc}</p>
          </div>

          <div style={{ background: '#fff', border: '1px solid #d9e1ea', borderRadius: '18px', boxShadow: '0 18px 45px rgba(16,24,40,.08)', overflow: 'hidden' }}>
            <div style={{ padding: '22px 26px 18px', borderBottom: '1px solid #edf1f5', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div style={{ fontWeight: '900', fontSize: '18px' }}>
                {i18n.qListTitle} <span style={{ fontSize: '14px', color: '#667085', fontWeight: 'normal', marginLeft: '8px' }}>({currentPage} / {totalPages} {i18n.pageText})</span>
              </div>
              <span style={{ padding: '6px 12px', borderRadius: '999px', background: '#f2f6fa', fontSize: '12px', fontWeight: '700' }}>{i18n.totalPrefix} {currentSectionQuestions.length} {i18n.qCountSuffix}</span>
            </div>

            <div style={{ padding: '6px 26px 12px' }}>
              {paginatedQuestions.map((q, idx) => {
                const globalIdx = (currentPage - 1) * QUESTIONS_PER_PAGE + idx;
                const optionsData = parseOptionsData(q.options_json);
                const optionsList = Array.isArray(optionsData.options) ? optionsData.options : [];
                const qType = (q.question_type || '').toLowerCase();

                const qText = lang === 'en' ? q.question_en : q.question_ko;
                const stemText = lang === 'en' ? optionsData.stem_en : optionsData.stem_ko;

                return (
                  <div key={q.id} style={{ padding: '22px 0', borderBottom: '1px solid #edf1f5', textAlign: 'left' }}>
                    <div style={{ display: 'grid', gridTemplateColumns: '44px minmax(0,1fr)', gap: '12px', alignItems: 'start' }}>
                      <div style={{ width: '34px', height: '34px', borderRadius: '11px', background: '#f2f5f8', color: '#475467', display: 'grid', placeItems: 'center', fontSize: '13px', fontWeight: '900' }}>{globalIdx + 1}</div>
                      <div style={{ fontSize: '15px', fontWeight: '700', lineHeight: 1.65, paddingTop: '3px', textAlign: 'left' }}>{qText}</div>
                    </div>

                    {stemText && (
                      <div style={{ margin: '14px 0 14px 56px', padding: '16px 18px', background: '#f7f9fc', border: '1px solid #e4e9f0', borderRadius: '13px', fontSize: '13px', whiteSpace: 'pre-line', textAlign: 'left' }}>
                        {stemText}
                      </div>
                    )}

                    {qType === 'likert' && (
                      <div style={{ margin: '16px 0 0 56px', display: 'grid', gridTemplateColumns: 'repeat(5, minmax(0, 1fr))', gap: '9px' }}>
                        {i18n.likert.map((label, lIdx) => {
                          const val = lIdx + 1;
                          const isChecked = answers[q.id] === val;
                          return (
                            <label key={val} style={{ border: `1px solid ${isChecked ? '#1c9a8b' : '#d9e1ea'}`, borderRadius: '12px', background: isChecked ? '#e9f7f4' : '#fff', minHeight: '48px', display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '8px', padding: '9px 12px', fontSize: '12px', cursor: 'pointer', textAlign: 'left' }}>
                              <input type="radio" name={`q-${q.id}`} value={val} checked={isChecked} onChange={() => handleRadioChange(q.id, val)} />
                              <span>{val}. {label}</span>
                            </label>
                          );
                        })}
                      </div>
                    )}

                    {qType === 'choice' && (
                      <div style={{ margin: '14px 0 0 56px', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
                        {optionsList.length > 0 ? (
                          optionsList.map((opt, optIdx) => {
                            const val = optIdx + 1;
                            const isChecked = answers[q.id] === val;
                            const optText = lang === 'en' ? (opt.en || opt.ko) : opt.ko;
                            return (
                              <label key={val} style={{ border: `1px solid ${isChecked ? '#1c9a8b' : '#d9e1ea'}`, borderRadius: '12px', background: isChecked ? '#e9f7f4' : '#fff', padding: '12px 14px', fontSize: '13px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '8px', textAlign: 'left' }}>
                                <input type="radio" name={`q-${q.id}`} value={val} checked={isChecked} onChange={() => handleRadioChange(q.id, val)} />
                                <span>{val}. {optText}</span>
                              </label>
                            );
                          })
                        ) : (
                          <div style={{ color: '#98a2b3', fontSize: '13px', textAlign: 'left' }}>{i18n.noOptions}</div>
                        )}
                      </div>
                    )}

                    {qType === 'sjt' && (
                      <div style={{ margin: '14px 0 0 56px', display: 'grid', gap: '10px' }}>
                        {optionsList.length > 0 ? (
                          optionsList.map((opt, optIdx) => {
                            const optText = lang === 'en' ? (opt.en || opt.ko) : opt.ko;
                            const isBest = answers[`sjt-${q.id}-best`] === optIdx;
                            const isWorst = answers[`sjt-${q.id}-worst`] === optIdx;

                            return (
                              <div key={optIdx} style={{ border: '1px solid #d9e1ea', borderRadius: '13px', padding: '13px 14px', background: '#fff', display: 'grid', gridTemplateColumns: '34px 1fr 180px', gap: '12px', alignItems: 'center' }}>
                                <div style={{ width: '32px', height: '32px', borderRadius: '99px', background: '#f2f5f8', display: 'grid', placeItems: 'center', fontSize: '13px', fontWeight: '900' }}>{String.fromCharCode(65 + optIdx)}</div>
                                <div style={{ fontSize: '13px', textAlign: 'left' }}>{optText}</div>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '6px' }}>
                                  <label style={{ border: `1px solid ${isBest ? '#1c9a8b' : '#d9e1ea'}`, borderRadius: '99px', padding: '7px 5px', fontSize: '11px', textAlign: 'center', background: isBest ? '#e9f7f4' : '#fff', cursor: 'pointer' }}>
                                    <input type="radio" name={`sjt-${q.id}-best`} checked={isBest} onChange={() => handleSJTChange(q.id, 'best', optIdx)} /> {i18n.sjtBest}
                                  </label>
                                  <label style={{ border: `1px solid ${isWorst ? '#1c9a8b' : '#d9e1ea'}`, borderRadius: '99px', padding: '7px 5px', fontSize: '11px', textAlign: 'center', background: isWorst ? '#e9f7f4' : '#fff', cursor: 'pointer' }}>
                                    <input type="radio" name={`sjt-${q.id}-worst`} checked={isWorst} onChange={() => handleSJTChange(q.id, 'worst', optIdx)} /> {i18n.sjtWorst}
                                  </label>
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          <div style={{ color: '#98a2b3', fontSize: '13px', textAlign: 'left' }}>{i18n.noOptions}</div>
                        )}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>

            {totalPages > 1 && (
              <div style={{ display: 'flex', justifyContent: 'center', gap: '6px', padding: '16px 0', borderTop: '1px solid #edf1f5' }}>
                {Array.from({ length: totalPages }, (_, i) => i + 1).map((pNum) => (
                  <button
                    key={pNum}
                    onClick={() => {
                      if (pNum > currentPage && !checkCurrentPageAnswered()) return;
                      setCurrentPage(pNum);
                      window.scrollTo(0, 0);
                    }}
                    style={{
                      width: '32px', height: '32px', borderRadius: '8px', border: '1px solid',
                      borderColor: pNum === currentPage ? '#1c9a8b' : '#d9e1ea',
                      background: pNum === currentPage ? '#1c9a8b' : '#fff',
                      color: pNum === currentPage ? '#fff' : '#344054',
                      fontWeight: '800', fontSize: '13px', cursor: 'pointer'
                    }}
                  >
                    {pNum}
                  </button>
                ))}
              </div>
            )}
          </div>
        </main>
      </div>

      {/* Footer Nav Bar */}
      <footer style={{ position: 'fixed', left: '286px', right: 0, bottom: 0, background: 'rgba(255,255,255,.94)', backdropFilter: 'blur(8px)', borderTop: '1px solid #d9e1ea', padding: '14px 34px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', zIndex: 40 }}>
        <div style={{ fontSize: '12px', color: '#667085' }}>
          {i18n.sections[currentSection].name} <span style={{ fontWeight: 'bold' }}>({currentPage} / {totalPages} {i18n.pageText})</span>
        </div>
        <div style={{ display: 'flex', gap: '10px' }}>
          {!isFirstOverall && (
            <button onClick={handlePrev} style={{ border: 0, borderRadius: '11px', padding: '11px 22px', fontWeight: '800', background: '#eef2f6', color: '#344054', cursor: 'pointer' }}>
              {i18n.prev}
            </button>
          )}
          {!isLastOverall ? (
            <button onClick={handleNext} style={{ border: 0, borderRadius: '11px', padding: '11px 22px', fontWeight: '800', background: '#1c9a8b', color: '#fff', cursor: 'pointer' }}>
              {i18n.next}
            </button>
          ) : (
            <button onClick={() => { if (checkCurrentPageAnswered()) setShowModal(true); }} style={{ border: 0, borderRadius: '11px', padding: '11px 22px', fontWeight: '800', background: '#12233f', color: '#fff', cursor: 'pointer' }}>
              {i18n.submit}
            </button>
          )}
        </div>
      </footer>

      {/* Toast Notification */}
      <div style={{ position: 'fixed', top: '88px', right: '24px', background: '#101828', color: '#fff', padding: '12px 18px', borderRadius: '11px', fontSize: '13px', fontWeight: '600', opacity: showToast ? 1 : 0, transition: '.25s', pointerEvents: 'none', zIndex: 99, boxShadow: '0 8px 20px rgba(0,0,0,0.2)' }}>
        {toastMsg}
      </div>

      {/* Submit Modal */}
      {showModal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', zIndex: 100 }}>
          <div style={{ width: 'min(520px,100%)', background: '#fff', borderRadius: '19px', padding: '26px' }}>
            <h2 style={{ margin: '0 0 7px', textAlign: 'left' }}>{i18n.modalTitle}</h2>
            <p style={{ color: '#667085', fontSize: '13px', textAlign: 'left' }}>{i18n.modalDesc}</p>
            <div style={{ margin: '18px 0', padding: '14px', borderRadius: '13px', background: '#f6f8fb', border: '1px solid #d9e1ea', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
              <div style={{ textAlign: 'left' }}>{i18n.answered} <b style={{ display: 'block', fontSize: '17px', color: '#12233f' }}>{answeredCount}</b></div>
              <div style={{ textAlign: 'left' }}>{i18n.unanswered} <b style={{ display: 'block', fontSize: '17px', color: '#12233f' }}>{totalQuestions - answeredCount}</b></div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '9px' }}>
              <button disabled={isSubmitting} onClick={() => setShowModal(false)} style={{ border: 0, borderRadius: '11px', padding: '11px 18px', fontWeight: '800', background: '#eef2f6', cursor: 'pointer' }}>
                {i18n.continue}
              </button>
              <button disabled={isSubmitting} onClick={() => handleSubmitFinal(false)} style={{ border: 0, borderRadius: '11px', padding: '11px 18px', fontWeight: '800', background: '#1c9a8b', color: '#fff', cursor: 'pointer', opacity: isSubmitting ? 0.7 : 1 }}>
                {isSubmitting ? i18n.submitting : i18n.finalSubmit}
              </button>
            </div>
          </div>
        </div>
      )}
      {showSuccessModal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,.65)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', zIndex: 200 }}>
          <div style={{ width: 'min(440px,100%)', background: '#fff', borderRadius: '20px', padding: '32px 28px', textAlign: 'center', boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1)' }}>
            <div style={{ width: '60px', height: '60px', background: '#e6f4f1', color: '#1c9a8b', borderRadius: '50%', display: 'grid', placeItems: 'center', margin: '0 auto 18px', fontSize: '28px', fontWeight: 'bold' }}>
              ✓
            </div>
            <h2 style={{ margin: '0 0 10px', fontSize: '21px', fontWeight: '800', color: '#101828' }}>
              {lang === 'en' ? 'Examination Completed' : '인적성검사 제출 완료'}
            </h2>
            <p style={{ margin: '0 0 24px', fontSize: '14px', color: '#667085', lineHeight: '1.5', whiteSpace: 'pre-line' }}>
              {lang === 'en'
                ? 'Your responses have been successfully submitted.\nThank you for your time.'
                : '모든 답안이 성공적으로 제출되었습니다.\n수고하셨습니다.'}
            </p>
            <button
              onClick={() => {
                setShowSuccessModal(false);
                if (onExamComplete) onExamComplete(); // 버튼 클릭 시에만 로그인 화면으로 이동
              }}
              style={{
                width: '100%',
                padding: '13px',
                borderRadius: '12px',
                border: 0,
                background: '#1c9a8b',
                color: '#fff',
                fontSize: '15px',
                fontWeight: '800',
                cursor: 'pointer',
                boxShadow: '0 4px 12px rgba(28,154,139,0.25)'
              }}
            >
              {lang === 'en' ? 'Exit' : '종료'}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

// -------------------------------------------------------------
// 관리자 페이지 (한글 명칭 적용 및 수정/토글 기능)
// -------------------------------------------------------------
function AdminHiddenPortal() {
  const [tab, setTab] = useState('candidates');
  const [candidatesList, setCandidatesList] = useState([]);
  const [questionsList, setQuestionsList] = useState([]);
  const [selectedCandidateIds, setSelectedCandidateIds] = useState([]);
  const [isExporting, setIsExporting] = useState(false);

  // 메일 발송 관련 상태
  const [emailModalOpen, setEmailModalOpen] = useState(false);
  const [emailLang, setEmailLang] = useState('ko');
  const [isSendingEmail, setIsSendingEmail] = useState(false);

  // 메일 템플릿 관리 상태 (ko/en 각각 subject, body)
  const [emailTemplates, setEmailTemplates] = useState({
    ko: { subject: '', body: '' },
    en: { subject: '', body: '' }
  });
  const [isSavingTemplate, setIsSavingTemplate] = useState(false);

  // Candidate Form
  const [candidateName, setCandidateName] = useState('');
  const [candidateEmail, setCandidateEmail] = useState('');
  const [createdCode, setCreatedCode] = useState('');

  // Question Form
  const [editingId, setEditingId] = useState(null);
  const [section, setSection] = useState('personality');
  const [questionType, setQuestionType] = useState('likert');
  const [questionKo, setQuestionKo] = useState('');
  const [questionEn, setQuestionEn] = useState('');
  const [stemKo, setStemKo] = useState('');
  const [stemEn, setStemEn] = useState('');
  const [opt1Ko, setOpt1Ko] = useState(''); const [opt1En, setOpt1En] = useState('');
  const [opt2Ko, setOpt2Ko] = useState(''); const [opt2En, setOpt2En] = useState('');
  const [opt3Ko, setOpt3Ko] = useState(''); const [opt3En, setOpt3En] = useState('');
  const [opt4Ko, setOpt4Ko] = useState(''); const [opt4En, setOpt4En] = useState('');

  // 초기화 확인 모달 상태
  const [resetTarget, setResetTarget] = useState({ isOpen: false, id: null, name: '' });

  // 일반 안내/에러 알림 모달 상태
  const [alertInfo, setAlertInfo] = useState({ isOpen: false, message: '' });

  const loadCandidates = () => {
    fetch(`${SERVER_BASE}/api/admin/candidates`)
      .then((res) => res.json())
      .then((data) => {
        setCandidatesList(data);
        setSelectedCandidateIds([]);
      });
  };

  const loadQuestions = () => {
    fetch(`${SERVER_BASE}/api/admin/questions`)
      .then((res) => res.json())
      .then((data) => setQuestionsList(data));
  };

  // 이메일 템플릿(ko/en) 목록 조회
  const loadEmailTemplates = () => {
    fetch(`${SERVER_BASE}/api/admin/email-templates`)
      .then((res) => res.json())
      .then((data) => {
        const next = { ko: { subject: '', body: '' }, en: { subject: '', body: '' } };
        (Array.isArray(data) ? data : []).forEach((t) => {
          if (t.lang === 'ko' || t.lang === 'en') {
            next[t.lang] = { subject: t.subject || '', body: t.body || '' };
          }
        });
        setEmailTemplates(next);
      })
      .catch((err) => console.error('메일 템플릿 조회 실패:', err));
  };

  useEffect(() => {
    if (tab === 'candidates') loadCandidates();
    if (tab === 'questions') loadQuestions();
    if (tab === 'email') loadEmailTemplates();
  }, [tab]);

  const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return '-';
    return d.toLocaleString('ko-KR', {
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hour12: false
    });
  };
  // 1. [초기화] 버튼 클릭 시 모달 열기
  const handleOpenResetModal = (candidateId, name) => {
    setResetTarget({ isOpen: true, id: candidateId, name });
  };

  // 2. 모달 내 '초기화 실행' 버튼 클릭 시 실제 API 호출
  const handleConfirmReset = async () => {
    const { id } = resetTarget;
    // 모달 닫기
    setResetTarget({ isOpen: false, id: null, name: '' });

    try {
      const res = await fetch(`${SERVER_BASE}/api/admin/candidates/${id}/reset`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' }
      });
      const data = await res.json();

      if (data.success) {
        setAlertInfo({ isOpen: true, message: '해당 지원자에 데이터가 모두 삭제되었습니다.' });
        loadCandidates(); // 목록 새로고침
      } else {
        setAlertInfo({ isOpen: true, message: data.message || '초기화에 실패했습니다.' });
      }
    } catch (err) {
      console.error(err);
      setAlertInfo({ isOpen: true, message: '초기화 요청 중 서버 오류가 발생했습니다.' });
    }
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedCandidateIds(candidatesList.map((c) => c.id));
    } else {
      setSelectedCandidateIds([]);
    }
  };

  const handleSelectCandidate = (id) => {
    setSelectedCandidateIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  // ⭐️ 선택된 응시자에게 안내 메일 발송 (언어 선택 모달 → 발송)
  const handleSendEmail = async () => {
    setIsSendingEmail(true);
    try {
      const res = await fetch(`${SERVER_BASE}/api/admin/send-email`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ candidateIds: selectedCandidateIds, lang: emailLang })
      });
      const data = await res.json();

      if (data.success) {
        setEmailModalOpen(false);
        setAlertInfo({ isOpen: true, message: data.message || '메일 발송이 완료되었습니다.' });
        loadCandidates(); // 발송일시 갱신을 위해 목록 새로고침
      } else {
        setAlertInfo({ isOpen: true, message: data.message || '메일 발송에 실패했습니다.' });
      }
    } catch (err) {
      console.error(err);
      setAlertInfo({ isOpen: true, message: '메일 발송 요청 중 서버 오류가 발생했습니다.' });
    } finally {
      setIsSendingEmail(false);
    }
  };

  // ⭐️ 이메일 템플릿(ko 또는 en) 저장
  const handleSaveTemplate = async (lang) => {
    setIsSavingTemplate(true);
    try {
      const res = await fetch(`${SERVER_BASE}/api/admin/email-templates/${lang}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(emailTemplates[lang])
      });
      const data = await res.json();
      setAlertInfo({
        isOpen: true,
        message: data.success ? '메일 템플릿이 저장되었습니다.' : (data.message || '템플릿 저장에 실패했습니다.')
      });
    } catch (err) {
      console.error(err);
      setAlertInfo({ isOpen: true, message: '템플릿 저장 중 서버 오류가 발생했습니다.' });
    } finally {
      setIsSavingTemplate(false);
    }
  };

  // ⭐️ [ 핵심 ] 응답값(Exam Results) 엑셀 다운로드 처리 함수
  const handleDownloadResponseExcel = async () => {
    if (selectedCandidateIds.length === 0) {
      alert('응답값을 다운로드할 응시자를 최소 1명 이상 선택해 주세요.');
      return;
    }

    setIsExporting(true);
    try {
      // 1. 선택된 응시자들의 상세 답안 API 호출
      const res = await fetch(`${SERVER_BASE}/api/admin/export-answers`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ candidateIds: selectedCandidateIds })
      });
      const exportData = await res.json(); // { questions: [...], responses: [...] }

      if (!exportData.success) {
        throw new Error(exportData.message || '응답 데이터 조회 실패');
      }

      const { questions, responses } = exportData;

      // 2. CSV 헤더 구성 (응시자 기본정보 + Q1, Q2, Q3... 문항 제목)
      const headers = [
        '응시자 ID',
        '이름',
        '이메일',
        '인증코드',
        '응시 상태',
        '제출 일시',
        ...questions.map((q) => `"Q${q.id}. ${q.question_ko.replace(/"/g, '""')}"`)
      ];

      // 3. 각 응시자별 응답 Row 구성
      const rows = responses.map((cand) => {
        const answerCells = questions.map((q) => {
          const ans = cand.answers[q.id];
          return ans !== undefined && ans !== null ? `"${String(ans).replace(/"/g, '""')}"` : '""';
        });

        return [
          cand.id,
          `"${cand.name}"`,
          `"${cand.email}"`,
          `"${cand.auth_code || ''}"`,
          `"${STATUS_MAP[cand.status]?.label || cand.status}"`,
          `"${formatDate(cand.submitted_at)}"`,
          ...answerCells
        ].join(',');
      });

      // 4. UTF-8 BOM 추가 후 파일 다운로드
      const csvContent = '\uFEFF' + [headers.join(','), ...rows].join('\n');
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      const today = new Date().toISOString().slice(0, 10);
      link.href = url;
      link.setAttribute('download', `응시자_응답내역_${today}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

    } catch (err) {
      console.error(err);
      alert('응답 데이터 다운로드 중 오류가 발생했습니다.');
    } finally {
      setIsExporting(false);
    }
  };

  const resetQuestionForm = () => {
    setEditingId(null);
    setSection('personality');
    setQuestionType('likert');
    setQuestionKo(''); setQuestionEn('');
    setStemKo(''); setStemEn('');
    setOpt1Ko(''); setOpt1En(''); setOpt2Ko(''); setOpt2En('');
    setOpt3Ko(''); setOpt3En(''); setOpt4Ko(''); setOpt4En('');
  };

  const handleAddCandidate = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch(`${SERVER_BASE}/api/admin/candidates`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: candidateName, email: candidateEmail })
      });
      
      const data = await res.json();
      console.log(data);

      if (data.success) {
        setCreatedCode(data.authCode);
        setCandidateName('');
        setCandidateEmail('');
        loadCandidates();
      } else {
        // ⭐️ 중복 등의 이유로 실패 시 모달 창으로 메시지 표시
        setAlertInfo({ 
          isOpen: true, 
          message: data.message || '응시자 등록에 실패했습니다.' 
        });
      }
    } catch (err) {
      console.error(err);
      setAlertInfo({ 
        isOpen: true, 
        message: '서버 통신 중 오류가 발생했습니다.' 
      });
    }
  };
  const handleSaveQuestion = async (e) => {
    e.preventDefault();
    let optionsJson = [];
    if (questionType === 'choice' || questionType === 'sjt') {
      optionsJson = [
        { ko: opt1Ko, en: opt1En || opt1Ko },
        { ko: opt2Ko, en: opt2En || opt2Ko },
        { ko: opt3Ko, en: opt3En || opt3Ko },
        { ko: opt4Ko, en: opt4En || opt4Ko }
      ];
    }

    const payload = {
      section, questionType, questionKo,
      questionEn: questionEn || questionKo,
      stemKo, stemEn: stemEn || stemKo, optionsJson
    };

    const url = editingId
      ? `${SERVER_BASE}/api/admin/questions/${editingId}`
      : `${SERVER_BASE}/api/admin/questions`;
    const method = editingId ? 'PUT' : 'POST';

    try {
      const res = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      const data = await res.json();
      if (data.success) {
        resetQuestionForm();
        loadQuestions();
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleEditClick = (q) => {
    setEditingId(q.id);
    setSection(q.section);
    setQuestionType(q.question_type);
    setQuestionKo(q.question_ko || '');
    setQuestionEn(q.question_en || '');

    const opts = parseOptionsData(q.options_json);
    setStemKo(opts.stem_ko || '');
    setStemEn(opts.stem_en || '');

    const list = Array.isArray(opts.options) ? opts.options : [];
    setOpt1Ko(list[0]?.ko || ''); setOpt1En(list[0]?.en || '');
    setOpt2Ko(list[1]?.ko || ''); setOpt2En(list[1]?.en || '');
    setOpt3Ko(list[2]?.ko || ''); setOpt3En(list[2]?.en || '');
    setOpt4Ko(list[3]?.ko || ''); setOpt4En(list[3]?.en || '');

    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleToggleActive = async (id, currentStatus) => {
    try {
      const res = await fetch(`${SERVER_BASE}/api/admin/questions/${id}/active`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ is_active: !currentStatus })
      });
      const data = await res.json();
      if (data.success) loadQuestions();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div style={styles.container}>
      {/* 상단 헤더 */}
      <header style={styles.header}>
        <div>
          <h1 style={styles.title}>🔒 관리자 포털 (Admin Center)</h1>
          <p style={styles.subtitle}>응시자 데이터 모니터링 및 문항을 관리합니다.</p>
        </div>
      </header>

      {/* 네비게이션 탭 */}
      <div style={styles.tabContainer}>
        <button
          onClick={() => setTab('candidates')}
          style={tab === 'candidates' ? styles.activeTab : styles.tab}
        >
          👥 응시자 데이터 & 응답 관리
        </button>
        <button
          onClick={() => setTab('questions')}
          style={tab === 'questions' ? styles.activeTab : styles.tab}
        >
          📝 문항 관리
        </button>
        <button
          onClick={() => setTab('email')}
          style={tab === 'email' ? styles.activeTab : styles.tab}
        >
          ✉️ 메일 템플릿 관리
        </button>
      </div>

      {tab === 'candidates' ? (
        <div>
          {/* 신규 응시자 등록 카드 */}
          <div style={styles.card}>
            <h3 style={styles.cardTitle}>➕ 신규 응시자 추가</h3>
            <form onSubmit={handleAddCandidate} style={styles.formRow}>
              <div style={styles.inputGroup}>
                <label style={styles.label}>응시자 성함</label>
                <input
                  type="text"
                  required
                  placeholder="예: 홍길동"
                  value={candidateName}
                  onChange={(e) => setCandidateName(e.target.value)}
                  style={styles.input}
                />
              </div>
              <div style={styles.inputGroup}>
                <label style={styles.label}>이메일 주소</label>
                <input
                  type="email"
                  required
                  placeholder="candidate@email.com"
                  value={candidateEmail}
                  onChange={(e) => setCandidateEmail(e.target.value)}
                  style={styles.input}
                />
              </div>
              <button type="submit" style={styles.primaryBtn}>
                응시자 추가 (고유 인증코드 발급)
              </button>
            </form>
            {createdCode && (
              <div style={styles.codeAlert}>
                🎉 생성된 고유 인증번호: <strong>{createdCode}</strong>
              </div>
            )}
          </div>

          {/* 응시자 목록 & 엑셀 다운로드 영역 */}
          <div style={styles.card}>
            <div style={styles.tableHeaderRow}>
              <div>
                <h3 style={styles.cardTitle}>📋 등록 응시자 목록 ({candidatesList.length}명)</h3>
                <span style={{ fontSize: '13px', color: '#64748b' }}>체크한 응시자의 상세 문항별 답변을 엑셀로 추출합니다.</span>
              </div>
              <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                {selectedCandidateIds.length > 0 && (
                  <button
                    onClick={() => { setEmailLang('ko'); setEmailModalOpen(true); }}
                    style={styles.emailBtn}
                  >
                    ✉️ 메일 보내기 ({selectedCandidateIds.length}명)
                  </button>
                )}
                <button
                  onClick={handleDownloadResponseExcel}
                  disabled={isExporting}
                  style={{
                    ...styles.excelBtn,
                    opacity: isExporting ? 0.6 : 1,
                    cursor: isExporting ? 'not-allowed' : 'pointer'
                  }}
                >
                  📊 {isExporting ? '데이터 생성 중...' : `선택 응시자 응답 엑셀 다운로드 (${selectedCandidateIds.length}명)`}
                </button>
              </div>
            </div>

            <div style={styles.tableWrapper}>
              <table style={styles.table}>
                <thead>
                  <tr>
                    <th style={{ ...styles.th, width: '40px', textAlign: 'center' }}>
                      <input
                        type="checkbox"
                        onChange={handleSelectAll}
                        checked={candidatesList.length > 0 && selectedCandidateIds.length === candidatesList.length}
                      />
                    </th>
                    <th style={styles.th}>ID</th>
                    <th style={styles.th}>이름</th>
                    <th style={styles.th}>이메일</th>
                    <th style={styles.th}>고유 인증코드</th>
                    <th style={styles.th}>상태</th>
                    <th style={styles.th}>생성일시</th>
                    <th style={styles.th}>응시 시작일시</th>
                    <th style={styles.th}>제출일시</th>
                    <th style={styles.th}>메일발송일시</th>
                    {/* ⭐️ 리셋 버튼용 헤더 추가 */}
                    <th style={{ ...styles.th, width: '80px', textAlign: 'center' }}>관리</th>
                  </tr>
                </thead>
                <tbody>
                  {candidatesList.map((c) => {
                    const statusInfo = STATUS_MAP[c.status] || { label: c.status || '대기', color: '#475569', bg: '#f1f5f9' };
                    const isSelected = selectedCandidateIds.includes(c.id);

                    return (
                      <tr key={c.id} style={{ ...styles.tr, backgroundColor: isSelected ? '#f0fdf4' : '#fff' }}>
                        <td style={{ ...styles.td, textAlign: 'center' }}>
                          <input
                            type="checkbox"
                            checked={isSelected}
                            onChange={() => handleSelectCandidate(c.id)}
                          />
                        </td>
                        <td style={styles.td}>{c.id}</td>
                        <td style={{ ...styles.td, fontWeight: '600' }}>{c.name}</td>
                        <td style={styles.td}>{c.email}</td>
                        <td style={{ ...styles.td, color: '#0d9488', fontWeight: 'bold' }}>{c.auth_code}</td>
                        <td style={styles.td}>
                          <span style={{ ...styles.badge, color: statusInfo.color, backgroundColor: statusInfo.bg }}>
                            {statusInfo.label}
                          </span>
                        </td>
                        <td style={styles.dateTd}>{formatDate(c.created_at)}</td>
                        <td style={styles.dateTd}>{formatDate(c.started_at)}</td>
                        <td style={styles.dateTd}>{formatDate(c.submitted_at)}</td>
                        <td style={styles.dateTd}>{formatDate(c.email_sent_at)}</td>

                        {/* ⭐️ 리셋 버튼 추가 */}
                        <td style={{ ...styles.td, textAlign: 'center' }}>
                          { c.status !== 'READY' && c.status !== 'COMPLETED' && 
                            <button
                              onClick={() => handleOpenResetModal(c.id, c.name)}
                              style={styles.resetBtn}
                            >
                              🔄 리셋
                            </button>
                          } 
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      ) : tab === 'questions' ? (
        <div>
          {/* 문항 등록/수정 폼 카드 */}
          <div style={editingId ? styles.questionCardEditing : styles.questionCard}>
            <div style={styles.tableHeaderRow}>
              <h3 style={styles.cardTitle}>{editingId ? `📝 문항 수정 (ID: ${editingId})` : '➕ 신규 문항 추가'}</h3>
              {editingId && (
                <button onClick={resetQuestionForm} style={styles.cancelBtn}>
                  취소
                </button>
              )}
            </div>

            <form onSubmit={handleSaveQuestion}>
              <div style={styles.formGrid}>
                <div>
                  <label style={styles.label}>검사 영역</label>
                  <select value={section} onChange={(e) => setSection(e.target.value)} style={styles.input}>
                    <option value="personality">Ⅰ. 일반 인성검사</option>
                    <option value="workstyle">Ⅱ. 업무성향검사</option>
                    <option value="aptitude">Ⅲ. 적성·인지능력검사</option>
                    <option value="sjt">Ⅳ. 직무상황판단검사 (SJT)</option>
                    <option value="domain_knowledge">Ⅴ. 기초 직무이해</option>
                  </select>
                </div>
                <div>
                  <label style={styles.label}>문항 유형</label>
                  <select value={questionType} onChange={(e) => setQuestionType(e.target.value)} style={styles.input}>
                    <option value="likert">리커트 5점 척도</option>
                    <option value="choice">4지선다형</option>
                    <option value="sjt">직무상황판단 (최적/최악)</option>
                  </select>
                </div>
              </div>

              <div style={{ marginTop: '12px' }}>
                <label style={styles.label}>질문 내용 (한국어)</label>
                <input type="text" required style={styles.input} value={questionKo} onChange={(e) => setQuestionKo(e.target.value)} />
              </div>
              <div style={{ marginTop: '12px' }}>
                <label style={styles.label}>질문 내용 (English)</label>
                <input type="text" required style={styles.input} value={questionEn} onChange={(e) => setQuestionEn(e.target.value)} />
              </div>

              {(questionType === 'choice' || questionType === 'sjt') && (
                <div style={styles.subFormBox}>
                  <div style={{ marginBottom: '10px' }}>
                    <label style={styles.label}>지문/상황 설명 (한국어)</label>
                    <textarea rows={2} style={styles.textarea} value={stemKo} onChange={(e) => setStemKo(e.target.value)} />
                  </div>
                  <div style={{ marginBottom: '10px' }}>
                    <label style={styles.label}>지문/상황 설명 (English)</label>
                    <textarea rows={2} style={styles.textarea} value={stemEn} onChange={(e) => setStemEn(e.target.value)} />
                  </div>

                  <label style={{ ...styles.label, marginTop: '10px' }}>4개 선택지 입력</label>
                  <div style={styles.optionGrid}>
                    <input placeholder="보기 1 (KO)" style={styles.input} value={opt1Ko} onChange={(e) => setOpt1Ko(e.target.value)} />
                    <input placeholder="Option 1 (EN)" style={styles.input} value={opt1En} onChange={(e) => setOpt1En(e.target.value)} />
                    <input placeholder="보기 2 (KO)" style={styles.input} value={opt2Ko} onChange={(e) => setOpt2Ko(e.target.value)} />
                    <input placeholder="Option 2 (EN)" style={styles.input} value={opt2En} onChange={(e) => setOpt2En(e.target.value)} />
                    <input placeholder="보기 3 (KO)" style={styles.input} value={opt3Ko} onChange={(e) => setOpt3Ko(e.target.value)} />
                    <input placeholder="Option 3 (EN)" style={styles.input} value={opt3En} onChange={(e) => setOpt3En(e.target.value)} />
                    <input placeholder="보기 4 (KO)" style={styles.input} value={opt4Ko} onChange={(e) => setOpt4Ko(e.target.value)} />
                    <input placeholder="Option 4 (EN)" style={styles.input} value={opt4En} onChange={(e) => setOpt4En(e.target.value)} />
                  </div>
                </div>
              )}

              <button
                type="submit"
                style={{
                  ...styles.primaryBtn,
                  marginTop: '16px',
                  backgroundColor: editingId ? '#d97706' : '#2563eb'
                }}
              >
                {editingId ? '💾 수정' : '✨ 저장'}
              </button>
            </form>
          </div>

          {/* 문항 목록 테이블 */}
          <div style={styles.card}>
            <h3 style={styles.cardTitle}>📜 등록된 문항 목록 ({questionsList.length}개)</h3>
            <div style={styles.tableWrapper}>
              <table style={styles.table}>
                <thead>
                  <tr>
                    <th style={{ ...styles.th, width: '50px' }}>ID</th>
                    <th style={styles.th}>영역</th>
                    <th style={styles.th}>유형</th>
                    <th style={styles.th}>질문 (KO)</th>
                    <th style={{ ...styles.th, width: '80px', textAlign: 'center' }}>상태</th>
                    <th style={{ ...styles.th, width: '130px', textAlign: 'center' }}>관리</th>
                  </tr>
                </thead>
                <tbody>
                  {questionsList.map((q) => {
                    const isActive = q.is_active !== false && q.is_active !== 0;
                    return (
                      <tr key={q.id} style={{ ...styles.tr }}>
                        <td style={{ ...styles.td, textAlign: 'center', opacity: isActive ? 1 : 0.55 }}>{q.id}</td>
                        <td style={{ ...styles.td, fontWeight: '600', fontSize: '13px', opacity: isActive ? 1 : 0.55 }}>
                          {SECTION_NAMES[q.section] || q.section}
                        </td>
                        <td style={{ ...styles.td, fontSize: '13px', opacity: isActive ? 1 : 0.55 }}>
                          {TYPE_NAMES[q.question_type] || q.question_type}
                        </td>
                        <td style={{...styles.td, opacity: isActive ? 1 : 0.55}}>{q.question_ko}</td>
                        <td style={{ ...styles.td, textAlign: 'center' }}>
                          <span style={{
                            ...styles.badge,
                            backgroundColor: isActive ? '#dcfce7' : '#fee2e2',
                            color: isActive ? '#15803d' : '#b91c1c'
                          }}>
                            {isActive ? '활성' : '비활성'}
                          </span>
                        </td>
                        <td style={{ ...styles.td, textAlign: 'center' }}>
                          <div style={{ display: 'flex', gap: '6px', justifyContent: 'center' }}>
                            <button onClick={() => handleEditClick(q)} style={styles.editBtn}>
                              수정
                            </button>
                            <button
                              onClick={() => handleToggleActive(q.id, isActive)}
                              style={{
                                ...styles.toggleBtn,
                                backgroundColor: isActive ? '#ef4444' : '#10b981'
                              }}
                            >
                              {isActive ? '비활성화' : '활성화'}
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      ) : (
        <div>
          {/* 이메일 템플릿 관리 (한국어 / 영어) */}
          <div style={styles.card}>
            <h3 style={styles.cardTitle}>ℹ️ 사용 가능한 치환 변수 (플레이스홀더)</h3>
            <p style={{ fontSize: '13px', color: '#64748b', lineHeight: '1.6', margin: 0 }}>
              메일 제목/본문에 아래 변수를 입력하면 발송 시 실제 값으로 자동 치환됩니다.<br />
              <code style={styles.codeTag}>{'{username}'}</code> — 응시자 이름 &nbsp;|&nbsp;
              <code style={styles.codeTag}>{'{key}'}</code> — 고유 인증번호(auth_code)
            </p>
          </div>

          {['ko', 'en'].map((langKey) => (
            <div style={styles.card} key={langKey}>
              <div style={styles.tableHeaderRow}>
                <h3 style={styles.cardTitle}>
                  {langKey === 'ko' ? '🇰🇷 한국어 템플릿' : '🇺🇸 English Template'}
                </h3>
                <button
                  onClick={() => handleSaveTemplate(langKey)}
                  disabled={isSavingTemplate}
                  style={{ ...styles.primaryBtn, opacity: isSavingTemplate ? 0.6 : 1 }}
                >
                  {isSavingTemplate ? '저장 중...' : '💾 저장'}
                </button>
              </div>
              <div style={{ marginBottom: '12px' }}>
                <label style={styles.label}>메일 제목</label>
                <input
                  type="text"
                  style={styles.input}
                  value={emailTemplates[langKey].subject}
                  onChange={(e) =>
                    setEmailTemplates((prev) => ({
                      ...prev,
                      [langKey]: { ...prev[langKey], subject: e.target.value }
                    }))
                  }
                />
              </div>
              <div>
                <label style={styles.label}>메일 본문</label>
                <textarea
                  rows={8}
                  style={styles.textarea}
                  value={emailTemplates[langKey].body}
                  onChange={(e) =>
                    setEmailTemplates((prev) => ({
                      ...prev,
                      [langKey]: { ...prev[langKey], body: e.target.value }
                    }))
                  }
                />
              </div>
            </div>
          ))}
        </div>
      )}

      {/* 메일 발송 - 언어 선택 모달 */}
      {emailModalOpen && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalContent}>
            <h3 style={{ marginTop: 0, color: '#0f172a' }}>✉️ 안내 메일 발송</h3>
            <p style={{ color: '#334155', lineHeight: '1.5', margin: '16px 0' }}>
              선택된 <strong>{selectedCandidateIds.length}명</strong>의 응시자에게 발송할 언어를 선택해 주세요.
            </p>
            <div style={{ display: 'flex', gap: '10px', marginBottom: '8px' }}>
              <label style={styles.langRadioLabel}>
                <input
                  type="radio"
                  name="emailLang"
                  checked={emailLang === 'ko'}
                  onChange={() => setEmailLang('ko')}
                />
                &nbsp;🇰🇷 한국어
              </label>
              <label style={styles.langRadioLabel}>
                <input
                  type="radio"
                  name="emailLang"
                  checked={emailLang === 'en'}
                  onChange={() => setEmailLang('en')}
                />
                &nbsp;🇺🇸 English
              </label>
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', marginTop: '20px' }}>
              <button
                onClick={() => setEmailModalOpen(false)}
                disabled={isSendingEmail}
                style={styles.modalCancelBtn}
              >
                취소
              </button>
              <button
                onClick={handleSendEmail}
                disabled={isSendingEmail}
                style={{ ...styles.modalPrimaryBtn, opacity: isSendingEmail ? 0.6 : 1 }}
              >
                {isSendingEmail ? '발송 중...' : '발송'}
              </button>
            </div>
          </div>
        </div>
      )}

      {resetTarget.isOpen && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalContent}>
            <h3 style={{ marginTop: 0, color: '#dc2626' }}>⚠️ 지원자 데이터 리셋</h3>
            <p style={{ color: '#334155', lineHeight: '1.5', margin: '16px 0' }}>
              <strong>[{resetTarget.name}]</strong> 지원자의 응시 상태를 <strong>대기</strong>로 변경하고,<br />
              기존 제출된 <strong>데이터를 모두 삭제</strong>하시겠습니까?
            </p>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', marginTop: '20px' }}>
              <button
                onClick={() => setResetTarget({ isOpen: false, id: null, name: '' })}
                style={styles.modalCancelBtn}
              >
                취소
              </button>
              <button
                onClick={handleConfirmReset}
                style={styles.modalConfirmBtn}
              >
                삭제
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 2. 알림 메시지 Modal (alert 대체) */}
      {alertInfo.isOpen && (
        <div style={styles.modalOverlay}>
          <div style={{ ...styles.modalContent, maxWidth: '360px' }}>
            <h3 style={{ marginTop: 0, fontSize: '18px', color: '#0f172a' }}>🔔 안내</h3>
            <p style={{ color: '#475569', margin: '16px 0', fontSize: '15px' }}>
              {alertInfo.message}
            </p>
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
              <button
                onClick={() => setAlertInfo({ isOpen: false, message: '' })}
                style={styles.modalPrimaryBtn}
              >
                확인
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// 🎨 경고 100% 퇴치용 깔끔한 styles 객체
const styles = {
  // --- 모달 인라인 스타일 ---
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(15, 23, 42, 0.55)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
    backdropFilter: 'blur(2px)',
  },
  modalContent: {
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    padding: '24px',
    width: '90%',
    maxWidth: '420px',
    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
  },
  modalCancelBtn: {
    padding: '8px 16px',
    fontSize: '14px',
    fontWeight: '600',
    color: '#64748b',
    backgroundColor: '#f1f5f9',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
  },
  modalConfirmBtn: {
    padding: '8px 16px',
    fontSize: '14px',
    fontWeight: '600',
    color: '#ffffff',
    backgroundColor: '#dc2626',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
  },
  modalPrimaryBtn: {
    padding: '8px 18px',
    fontSize: '14px',
    fontWeight: '600',
    color: '#ffffff',
    backgroundColor: '#2563eb',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
  },
  resetBtn: {
    padding: '4px 8px',
    fontSize: '12px',
    fontWeight: '600',
    color: '#dc2626',
    backgroundColor: '#fef2f2',
    border: '1px solid #fecaca',
    borderRadius: '4px',
    cursor: 'pointer',
    transition: 'all 0.2s',
  },
  container: {
    padding: '32px',
    maxWidth: '1280px',
    margin: '0 auto',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    backgroundColor: '#f8fafc',
    minHeight: '100vh',
    color: '#0f172a'
  },
  header: {
    marginBottom: '24px',
    borderBottom: '1px solid #e2e8f0',
    paddingBottom: '16px'
  },
  title: {
    fontSize: '24px',
    fontWeight: '700',
    color: '#1e293b',
    margin: 0
  },
  subtitle: {
    fontSize: '14px',
    color: '#64748b',
    marginTop: '4px'
  },
  tabContainer: {
    display: 'flex',
    gap: '8px',
    marginBottom: '20px'
  },
  tab: {
    padding: '10px 18px',
    borderRadius: '8px',
    border: 'none',
    backgroundColor: '#e2e8f0',
    color: '#475569',
    fontWeight: '600',
    cursor: 'pointer',
    fontSize: '14px',
    transition: 'all 0.2s'
  },
  activeTab: {
    padding: '10px 18px',
    borderRadius: '8px',
    border: 'none',
    backgroundColor: '#2563eb',
    color: '#ffffff',
    fontWeight: '600',
    cursor: 'pointer',
    fontSize: '14px',
    boxShadow: '0 2px 4px rgba(37, 99, 235, 0.2)'
  },
  // 일반 기본 카드 (border 단축형만 사용)
  card: {
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    padding: '24px',
    marginBottom: '24px',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
    border: '1px solid #e2e8f0'
  },
  // 질문 추가 전용 카드 (borderLeft를 쓰지 않고 outline/boxShadow로 표현)
  questionCard: {
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    padding: '24px',
    marginBottom: '24px',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
    border: '1px solid #3b82f6'
  },
  // 질문 수정 전용 카드 (border 단축형만 사용하여 충돌 원천 차단)
  questionCardEditing: {
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    padding: '24px',
    marginBottom: '24px',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
    border: '2px solid #f59e0b'
  },
  cardTitle: {
    fontSize: '16px',
    fontWeight: '700',
    margin: '0 0 16px 0',
    color: '#1e293b'
  },
  formRow: {
    display: 'flex',
    gap: '12px',
    alignItems: 'flex-end',
    flexWrap: 'wrap'
  },
  formGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '16px'
  },
  inputGroup: {
    flex: '1',
    minWidth: '200px'
  },
  label: {
    display: 'block',
    fontSize: '13px',
    fontWeight: '600',
    color: '#334155',
    marginBottom: '6px'
  },
  input: {
    width: '100%',
    padding: '9px 12px',
    borderRadius: '6px',
    border: '1px solid #cbd5e1',
    fontSize: '14px',
    outline: 'none',
    boxSizing: 'border-box'
  },
  textarea: {
    width: '100%',
    padding: '8px 12px',
    borderRadius: '6px',
    border: '1px solid #cbd5e1',
    fontSize: '14px',
    boxSizing: 'border-box'
  },
  primaryBtn: {
    padding: '10px 20px',
    backgroundColor: '#2563eb',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    fontWeight: '600',
    cursor: 'pointer',
    fontSize: '14px'
  },
  excelBtn: {
    padding: '9px 18px',
    backgroundColor: '#059669',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    fontWeight: '600',
    fontSize: '14px',
    boxShadow: '0 2px 4px rgba(5, 150, 105, 0.15)'
  },
  emailBtn: {
    padding: '9px 18px',
    backgroundColor: '#7c3aed',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    fontWeight: '600',
    fontSize: '14px',
    cursor: 'pointer',
    boxShadow: '0 2px 4px rgba(124, 58, 237, 0.2)'
  },
  codeTag: {
    padding: '2px 6px',
    backgroundColor: '#f1f5f9',
    border: '1px solid #e2e8f0',
    borderRadius: '4px',
    fontSize: '12px',
    color: '#0f172a'
  },
  langRadioLabel: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 14px',
    borderRadius: '6px',
    border: '1px solid #cbd5e1',
    fontSize: '14px',
    fontWeight: '600',
    color: '#334155',
    cursor: 'pointer'
  },
  cancelBtn: {
    padding: '6px 12px',
    backgroundColor: '#64748b',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    fontSize: '12px',
    cursor: 'pointer'
  },
  editBtn: {
    padding: '4px 10px',
    backgroundColor: '#2563eb',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    fontSize: '12px',
    cursor: 'pointer'
  },
  toggleBtn: {
    padding: '4px 10px',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    fontSize: '12px',
    cursor: 'pointer'
  },
  codeAlert: {
    marginTop: '12px',
    padding: '10px 14px',
    backgroundColor: '#f0fdf4',
    border: '1px solid #bbf7d0',
    borderRadius: '6px',
    color: '#166534',
    fontSize: '14px'
  },
  tableHeaderRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '16px',
    flexWrap: 'wrap',
    gap: '12px'
  },
  tableWrapper: {
    overflowX: 'auto'
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '13px',
    textAlign: 'left'
  },
  th: {
    backgroundColor: '#f1f5f9',
    padding: '10px 12px',
    color: '#475569',
    fontWeight: '600',
    borderBottom: '1px solid #e2e8f0'
  },
  tr: {
    borderBottom: '1px solid #f1f5f9',
    transition: 'background-color 0.15s'
  },
  td: {
    padding: '12px',
    color: '#1e293b'
  },
  dateTd: {
    padding: '12px',
    color: '#64748b',
    fontSize: '12px'
  },
  badge: {
    padding: '3px 8px',
    borderRadius: '12px',
    fontSize: '12px',
    fontWeight: '600',
    display: 'inline-block'
  },
  subFormBox: {
    marginTop: '16px',
    backgroundColor: '#f8fafc',
    padding: '16px',
    borderRadius: '8px',
    border: '1px solid #e2e8f0'
  },
  optionGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '8px',
    marginTop: '8px'
  }
};

function AdminLoginForm({ onLoginSuccess }) {
  const [email, setEmail] = useState('');
  const [authCode, setAuthCode] = useState('');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg('');
    try {
      // 백엔드 관리자 로그인 API 호출 (SERVER_BASE 변수가 App.js 상단에 정의되어 있어야 함)
      const res = await fetch(`${SERVER_BASE}/api/admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, authCode })
      });
      const data = await res.json();
      
      if (data.success) {
        onLoginSuccess(data.admin);
      } else {
        setErrorMsg(data.message || '관리자 이메일 또는 인증번호가 올바르지 않습니다.');
      }
    } catch (err) {
      setErrorMsg('서버 연결에 실패했습니다.');
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc', display: 'grid', placeItems: 'center', padding: '20px' }}>
      <div style={{ background: '#fff', borderRadius: '18px', border: '1px solid #e2e8f0', padding: '36px', maxWidth: '420px', width: '100%', boxShadow: '0 10px 25px rgba(0,0,0,.05)', textAlign: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px', marginBottom: '20px' }}>
          <div style={{ width: '42px', height: '42px', borderRadius: '13px', background: '#1e293b', display: 'grid', placeItems: 'center', fontSize: '20px' }}>
            🔒
          </div>
          <div style={{ textAlign: 'left' }}>
            <div style={{ fontSize: '18px', fontWeight: '800', color: '#0f172a', lineHeight: '1.2' }}>관리자 포털 로그인</div>
            <div style={{ fontSize: '12px', color: '#64748b', lineHeight: '1.3', marginTop: '2px' }}>Admin Access Only</div>
          </div>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '16px', textAlign: 'left' }}>
            <label style={{ display: 'block', fontSize: '13px', fontWeight: '700', color: '#334155', marginBottom: '6px' }}>관리자 이메일</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={{ width: '100%', padding: '12px', borderRadius: '10px', border: '1px solid #cbd5e1', boxSizing: 'border-box' }}
            />
          </div>
          <div style={{ marginBottom: '24px', textAlign: 'left' }}>
            <label style={{ display: 'block', fontSize: '13px', fontWeight: '700', color: '#334155', marginBottom: '6px' }}>인증코드 (비밀번호)</label>
            <input
              type="password"
              required
              value={authCode}
              onChange={(e) => setAuthCode(e.target.value)}
              style={{ width: '100%', padding: '12px', borderRadius: '10px', border: '1px solid #cbd5e1', boxSizing: 'border-box' }}
            />
          </div>
          {errorMsg && <p style={{ color: '#ef4444', fontSize: '13px', marginBottom: '16px', textAlign: 'center' }}>{errorMsg}</p>}
          <button type="submit" style={{ width: '100%', padding: '14px', borderRadius: '11px', background: '#2563eb', color: '#fff', border: 'none', fontWeight: '800', fontSize: '15px', cursor: 'pointer' }}>
            로그인
          </button>
        </form>
      </div>
    </div>
  );
}

// -------------------------------------------------------------
// App 메인 컴포넌트
// -------------------------------------------------------------
function App() {
  const [candidate, setCandidate] = useState(() => {
    const saved = localStorage.getItem('gmv_current_candidate');
    return saved ? JSON.parse(saved) : null;
  });

  const [admin, setAdmin] = useState(() => {
    const saved = localStorage.getItem('gmv_admin_session');
    return saved ? JSON.parse(saved) : null;
  });
  
  const [currentPath, setCurrentPath] = useState(window.location.pathname);

  useEffect(() => {
    const handlePopState = () => {
      setCurrentPath(window.location.pathname);
    };
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  const handleLoginSuccess = (candidateData) => {
    setCandidate(candidateData);
    localStorage.setItem('gmv_current_candidate', JSON.stringify(candidateData));
  };

  const handleExamComplete = () => {
    setCandidate(null);
  };
  const handleAdminLoginSuccess = (adminData) => {
    setAdmin(adminData);
    localStorage.setItem('gmv_admin_session', JSON.stringify(adminData));
  };

  const handleAdminLogout = () => {
    setAdmin(null);
    localStorage.removeItem('gmv_admin_session');
  };

  if (currentPath === '/admin-secret') {
    // 관리자 로그인이 안 되어있으면 폼 렌더링
    if (!admin) {
      return <AdminLoginForm onLoginSuccess={handleAdminLoginSuccess} />;
    }
    // 로그인이 되어있으면 포털 렌더링 (로그아웃 함수 전달)
    return <AdminHiddenPortal admin={admin} onLogout={handleAdminLogout} />;
  }

  return (
    <div className="App">
      {!candidate ? (
        <LoginForm onLoginSuccess={handleLoginSuccess} />
      ) : (
        <ExamPage candidate={candidate} onExamComplete={handleExamComplete} />
      )}
    </div>
  );
}

export default App;